"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTitle = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var avatar_1 = require("../avatar");
var CardTitle = /** @class */function (_super) {
  __extends(CardTitle, _super);
  function CardTitle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CardTitle.prototype.render = function () {
    var _a;
    var _b = this.props,
      children = _b.children,
      className = _b.className,
      avatar = _b.avatar,
      avatarSize = _b.avatarSize,
      title = _b.title,
      subtitle = _b.subtitle;
    var customProps = _1.omit(this.props, Object.keys(CardTitle.propTypes));
    var cardTitleClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('card-title')] = true, _a[vdl_prefix_1.vdlPrefix('card-title--avatar')] = !!avatar, _a[vdl_prefix_1.vdlPrefix('card-title--no-avatar')] = !avatar, _a);
    return react_1.default.createElement("div", __assign({}, customProps, {
      className: classnames_1.classNames(className, cardTitleClasses)
    }), typeof avatar === 'string' ? react_1.default.createElement(avatar_1.Avatar, {
      url: avatar,
      size: avatarSize,
      className: vdl_prefix_1.vdlPrefix('card-title__avatar')
    }) : avatar, react_1.default.createElement("div", null, title && react_1.default.createElement("h5", {
      className: vdl_prefix_1.vdlPrefix('card-title__title')
    }, title), children && typeof children === 'string' && react_1.default.createElement("h5", {
      className: vdl_prefix_1.vdlPrefix('card-title__title')
    }, children), subtitle && react_1.default.createElement("p", {
      className: vdl_prefix_1.vdlPrefix('card-title__subtitle')
    }, subtitle), children && typeof children !== 'string' && children));
  };
  CardTitle.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    title: prop_types_1.default.node,
    subtitle: prop_types_1.default.node,
    /**
     *  A string URL or Element to specify an avatar in the title
     */
    avatar: prop_types_1.default.node,
    avatarSize: avatar_1.Avatar.propTypes.size
  };
  CardTitle.defaultProps = {
    avatarSize: 'sm'
  };
  return CardTitle;
}(react_1.default.PureComponent);
exports.CardTitle = CardTitle;